import React from 'react';
import { useTheme } from '@emotion/react';
import { Checkbox } from '@mui/material';

/**
 * A checkbox that stays on brand when checked.
 *
 * MUI colours the checked state from the palette's primary, which here reads as
 * a disabled grey, so the checked colour is set explicitly.
 */
const PlanCheckbox = ({ sx = {}, ...props }) => {
    const theme = useTheme();
    return (
        <Checkbox
            size="small"
            sx={{
                color: theme.palette.customColors.g75,
                '&.Mui-checked': { color: theme.palette.customColors.checkboxcolor },
                ...sx,
            }}
            {...props}
        />
    );
};

export default PlanCheckbox;
